/**
 * Lobby flows call `GET /stream/initial-state` (e.g. Bullion `enrichMatchesWithCricketStreamInitialState`).
 * Opening the played view immediately runs the same endpoint via `DecimalSocketContext` — prime once
 * so the first snapshot poll / bootstrap fetch can reuse data for ~15s without a duplicate HTTP call.
 */

const TTL_MS = 15_000;

const store = new Map<string, { expiresAt: number; snap: Record<string, unknown> }>();

/** Store per-match snapshots from an initial-state JSON body (keys = match ids). */
export function primeInitialStateSnapshotsFromApiBody(body: Record<string, unknown> | null | undefined): void {
  if (!body || typeof body !== "object") return;
  const now = Date.now();
  for (const [mid, snap] of Object.entries(body)) {
    if (!mid || !snap || typeof snap !== "object" || Array.isArray(snap)) continue;
    store.set(String(mid).trim(), { expiresAt: now + TTL_MS, snap: snap as Record<string, unknown> });
  }
}

/** Return and remove one primed snapshot for this match, if still fresh (one-shot). */
export function consumePrimedMatchInitialState(matchIdRaw: string): Record<string, unknown> | null {
  const mid = String(matchIdRaw || "").trim();
  if (!mid) return null;
  const e = store.get(mid);
  const now = Date.now();
  if (!e) return null;
  if (e.expiresAt <= now) {
    store.delete(mid);
    return null;
  }
  store.delete(mid);
  return e.snap;
}
